import React from "react";
import styled from "styled-components";
import {logEvent} from "../../utils/analytics";

import _ from "lodash";
import {
  GoogleNews,
  Pinterest,
  Giphy,
  Mastodon,
  Imgur,
  Reddit,
  Minds,
  Golden,
  ProductHunt,
  Bloomberg,
  Figma,
  NewsBreak,
  Npm,
  Linkedin,
  FacebookRound,
  XSocial,
  Github,
  Youtube,
  Instagram,
  Digg,
  Podcast,
  Rss,
  HuggingFace,
  CrunchBase,
  ViewBlock,
} from "../icons";
import {useState} from "react";

const SocialLinks = styled.div`
  display: flex;
  align-items: center;

  > * {
    background: none;
    display: flex;
    align-items: flex-end;

    .email-icon {
      position: relative;
      top: 2px;
    }
  }
  a {
    padding: 0.5rem;
    transition: all 0.3s linear;

    @media (max-width: 500px) {
      margin: 5px 5px;
    }

    :hover {
      transform: scale(1.1);
    }
  }

  img {
    max-width: 24px;
    image-rendering: pixelated;
  }
`;

const Layout = styled(SocialLinks)`
  flex-wrap: wrap;
  gap: 5px;

  a {
    border: none !important;
  }

  .social-input {
    padding: 10px;
    border: 1px solid #116b00;
    border-radius: 5px;
    color: #7b7b7b;
  }

  .edit-socials-btn {
    border: 1px solid;
    background: #194d00;
    cursor: pointer;
    padding: 10px;
    width: 100%;
    margin-top: 7px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;
    color: #fff;
    justify-content: center;
    :hover {
      background: #00000096;
      transition: 0.5s all;
    }
  }
  @media screen and (max-width: 770px) {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
  }

  ${props =>
    props.aboutPageStyle &&
    `
    ${
      props.aboutPageStyle.isMobile
        ? `
      justify-content: center;
      margin: 10px;
    `
        : ""
    }
    > a {
      padding: 10px;
      margin-right: 0;
      >img{
        width: 30px;
        height: 30px;
      }
    }
  `}
`;

const Follow = ({data = {}, nofollow, aboutPageStyle, colors, updateable = false, updateSocial}) => {
  const [showInput, setShowInput] = useState(false);
  const [editableSocial, setEditableSocial] = useState(data.socialMedia || {});

  const logSocialsEvent = name => {
    logEvent("Social Media Follow", `${name} Social Media Icon clicked`);
  };

  return (
    <Layout color={colors?.colors.mainTextColor} aboutPageStyle={aboutPageStyle ? aboutPageStyle : ""}>
      {!_.isEmpty(data.socialMedia) && (
        <>
          {_.map(updateable ? editableSocial : data.socialMedia, (social, key) => {
            let url = "#";
            if (key === "linkedin") url = social.includes("http") ? social : `https://www.linkedin.com/in/${social}`;
            else if (key === "facebook") url = social.includes("http") ? social : `https://facebook.com/${social}`;
            else if (key === "twitter") url = social.includes("http") ? social : `https://twitter.com/${social}`;
            else if (key === "github") url = social.includes("http") ? social : `https://github.com/${social}`;
            else if (key === "youtube")
              url = social.includes("http") ? social : social.url || `https://www.youtube.com/${social}`;
            else if (key === "instagram")
              url = social.includes("http") ? social : social.url || `https://www.instagram.com/${social}`;
            return key !== "linkedin" ? (
              <React.Fragment key={key}>
                <a
                  onClick={() => logSocialsEvent(key)}
                  href={`${url}?ref=hackernoon`}
                  target="_blank"
                  rel={nofollow ? "nofollow" : "dofollow"}
                  style={colors && {background: "transparent"}}
                >
                  {key === "facebook" ? <FacebookRound style={{width: "24px", fill: "#d7d7d7"}} /> : ""}
                  {key === "twitter" ? <XSocial style={{width: "24px", fill: "#d7d7d7"}} /> : ""}
                  {key === "github" ? <Github style={{width: "24px", fill: "#d7d7d7"}} /> : ""}
                  {key === "youtube" ? <Youtube style={{width: "24px", fill: "#d7d7d7"}} /> : ""}
                  {key === "instagram" ? <Instagram style={{width: "24px", fill: "#d7d7d7"}} /> : ""}
                </a>
                {updateable && showInput && (
                  <>
                    <input
                      className="social-input"
                      value={editableSocial[key] || ""}
                      onChange={e => setEditableSocial({...editableSocial, [key]: e.target.value})}
                    />
                  </>
                )}
              </React.Fragment>
            ) : (
              ""
            );
          })}
        </>
      )}
      {!_.isEmpty(editableSocial) && updateable && (
        <button
          className="edit-socials-btn"
          onClick={e => {
            if (!showInput) {
              setShowInput(true);
            } else {
              updateSocial(editableSocial).then(() => {
                setShowInput(false);
              });
            }
          }}
        >
          {showInput ? "Save" : "Update"}
        </button>
      )}
      {data.digg && (
        <a
          style={colors && {background: "transparent"}}
          href={data.digg}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Digg style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.podcast && (
        <a
          style={colors && {background: "transparent"}}
          href={data.podcast}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Podcast style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.rss && (
        <a
          style={colors && {background: "transparent"}}
          href={data.rss}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Rss style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.googleNews && (
        <a
          style={colors && {background: "transparent"}}
          href={data.googleNews}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <GoogleNews style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.pinterest && (
        <a
          style={colors && {background: "transparent"}}
          href={data.pinterest}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Pinterest style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.giphy && (
        <a
          style={colors && {background: "transparent"}}
          href={data.giphy}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Giphy style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.imgur && (
        <a
          style={colors && {background: "transparent"}}
          href={data.imgur}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Imgur style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.mastodon && (
        <a
          style={colors && {background: "transparent"}}
          href={data.mastodon}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Mastodon style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.minds && (
        <a
          style={colors && {background: "transparent"}}
          href={data.minds}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Minds style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.reddit && (
        <a
          style={colors && {background: "transparent"}}
          href={data.reddit}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Reddit style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.golden && (
        <a
          style={colors && {background: "transparent"}}
          href={data.golden}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Golden style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.productHunt && (
        <a
          style={colors && {background: "transparent"}}
          href={data.productHunt}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <ProductHunt style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.bloomberg && (
        <a
          style={colors && {background: "transparent"}}
          href={data.bloomberg}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Bloomberg style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.figma && (
        <a
          style={colors && {background: "transparent"}}
          href={data.figma}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Figma style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.newsBreak && (
        <a
          style={colors && {background: "transparent"}}
          href={data.newsBreak}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <NewsBreak style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.npm && (
        <a
          style={colors && {background: "transparent"}}
          href={data.npm}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <Npm style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.viewBlock && (
        <a
          style={colors && {background: "transparent"}}
          href={data.viewBlock}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <ViewBlock style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.huggingFace && (
        <a
          style={colors && {background: "transparent"}}
          href={data.huggingFace}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <HuggingFace style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.crunchBase && (
        <a
          style={colors && {background: "transparent"}}
          href={data.crunchBase}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
        >
          <CrunchBase style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
      {data.linkedin && (
        <a
          onClick={() => logSocialsEvent("linkedin")}
          key={data.linkedin}
          href={`${data.linkedin}?ref=hackernoon`}
          target="_blank"
          rel={nofollow ? "nofollow" : "dofollow"}
          style={colors && {background: "transparent"}}
        >
          <Linkedin style={{width: "24px", fill: "#d7d7d7"}} />
        </a>
      )}
    </Layout>
  );
};

export default Follow;
